import { request } from "@umijs/max";

export async function fetchProductListItems(listId: any) {
  return request(`/data/fetch_product_list_items/${listId}`);
}

export async function fetchDefaultPeopleListItems(params: { page?: number, pageSize?: number } = {}) {
  return request('/people-v2/default-list-items', {
    method: 'GET',
    params
  });
}

export async function fetchAllDefaultPeopleListItemsForExport() {
  return request('/people-v2/default-list-items-export', {
    method: 'GET'
  });
}

export async function fetchPhoneForListPerson(personData: any) {
  return request('/people-v2/fetch_phone', {
    method: 'POST',
    data: personData
  });
}